/**
 * @created : 2021/3/23
 * @author  : 王冲
 * @desc    : 外层UI框架
 */
import { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { middleware, regHook, getSyncHook } from '@weapp/utils';
import { MainFrameProps } from './types';
import { LayoutLogin, Main } from '../../lib';

@inject('mainStore')
@middleware('weappLayout', 'MainFrame')
@observer
class MainFrame extends Component<MainFrameProps, any>{
  componentDidMount() {
    // 注册事件测试
    // regHook('@weapp/layout', 'loginDefaultPage', () => `/task`);

    //默认登录跳转地址
    // window.weappLayout?.registerHook!('layoutLoginRedirectUrl', () => '/xxxxx');

    //获取并执行
    // let test = getSyncHook('@weapp/layout', 'loginDefaultPage');
    // test!(0);
  }

  loginSuccess = (ticket: any) => {
    window.ePassport?.layoutLogin(ticket, () => {
      this.props.mainStore?.changeLayoutLoginShown(false);
    });
  }
  render() {
    const { layoutLoginShown } = this.props.mainStore!;

    if (layoutLoginShown) {
      return <LayoutLogin callback={this.loginSuccess} weId={`${this.props.weId || ''}_spuh79`} />
    }
    return (
      <Main weId={`${this.props.weId || ''}_owcdec`} {...this.props} />
    )
  }
}

export default withRouter(MainFrame);


